import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AptitudeReportView } from "@/components/aptitude/AptitudeReportView";
import { Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export default function AptitudeReport() {
  const [report, setReport] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let interval;
    const check = async () => {
      try {
        const res = await api.get("/student/aptitude/report");
        setReport(res.data);
        setStatus("ready");
        clearInterval(interval);
      } catch {
        setStatus("pending");
      }
    };
    check();
    interval = setInterval(check, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-4xl mx-auto mb-6"><BrandLogo className="h-6" /></div>
      {status !== "ready" ? (
        <div className="flex flex-col items-center justify-center py-24 gap-3" data-testid="aptitude-report-pending">
          <Loader2 className="h-6 w-6 animate-spin text-indigo-500" />
          <p className="text-sm text-slate-500">Scoring your Aptitude Test — this usually takes under a minute...</p>
        </div>
      ) : (
        <AptitudeReportView report={report} />
      )}
    </div>
  );
}
